import { useContext } from "react";
import { Button, Col, Flex, Form, Row, notification } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/pro-regular-svg-icons";
import BounceLoader from "react-spinners/BounceLoader";

import { bgColor } from "../../../../providers/companyInfo";
import PageScoreCardFormContext from "./PageScoreCardFormContext";
import CustomCollapse from "../../../../providers/CustomCollapse";

export default function FormContent() {
	const {
		form,
		answers,
		onFinish,
		onValuesChange,
		collapseItems,
		collapseActiveKey,
		setCollapseActiveKey,
		setCheckError,
		lastActiveTab,
		setLastActiveTab,
		isLoadingSurveyList,
	} = useContext(PageScoreCardFormContext);

	const handleCheckKey = (key) => {
		let newKey = Number(key);

		// guard: if the key is not a number or less than 0 return -1
		if (isNaN(newKey) || newKey < 0) return -1;

		let currentItem = collapseItems[newKey];
		if (currentItem && currentItem.hidden) {
			newKey -= 1;
			newKey = handleCheckKey(newKey);
		}
		return newKey;
	};

	const areAllRequiredAnswered = (formValues = {}) => {
		// console.log("formValues: ", formValues);
		// console.log("collapseItems: ", collapseItems);
		// iterate over visible (non-hidden) collapse items and ensure all required questions have answers
		for (let i = 0; i < collapseItems.length; i++) {
			const item = collapseItems[i];
			if (!item || item.hidden) continue;
			const data = item?.data;
			const form_questions = data?.form_questions || [];

			for (let q of form_questions) {
				if (q.required) {
					const answer = formValues[`q_${q.id}`];
					if (
						answer === undefined ||
						answer === null ||
						answer === "" ||
						answer === 0
					) {
						return false;
					}
				}
			}
		}
		return true;
	};

	const handleChange = (keys) => {
		console.log("message: ", keys);
		let key = Array.isArray(keys) ? keys[keys.length - 1] : keys;
		console.log("key: ", key);
		// if (!keys || keys.length === 0) return;
		// const activeKey = keys[keys.length - 1]; // last opened
		// const el = panelRefs.current[activeKey];
		// if (el) {
		// 	el.scrollIntoView({
		// 		behavior: "smooth",
		// 		block: "center", // center in viewport
		// 	});
		// }
		// setTimeout(() => {
		// 	let el = document
		// 		.querySelector(`#form-collapse-item-${key}`)
		// 		?.closest(".ant-collapse-item");
		// 	console.log("el: ", el);
		// 	if (el) {
		// 		// add margin top -80px to el position

		// 		// el.scroll({
		// 		// 	top: el.getBoundingClientRect().top - 80 + window.pageYOffset,
		// 		// 	behavior: "smooth",
		// 		// });
		// 		// el.scrollIntoView({
		// 		// 	behavior: "smooth",
		// 		// 	block: "start",
		// 		// 	inline: "nearest",
		// 		// });

		// 		const targetPosition =
		// 			el.getBoundingClientRect().top + window.pageYOffset - 30;

		// 		// Scroll to the calculated position
		// 		window.scrollTo({
		// 			top: targetPosition,
		// 			behavior: "smooth",
		// 		});
		// 		// window.scrollBy({
		// 		// 	top: -80,
		// 		// 	left: 0,
		// 		// 	behavior: "smooth",
		// 		// });
		// 	}
		// }, 500);
		// Use requestAnimationFrame for better mobile performance
		requestAnimationFrame(() => {
			setTimeout(() => {
				let el = document
					.querySelector(`#form-collapse-item-${key}`)
					?.closest(".ant-collapse-item");
				console.log("el: ", el);

				if (el) {
					// For mobile, use a larger offset and ensure element is fully visible
					const rect = el.getBoundingClientRect();
					const offset = 0; // larger offset for mobile

					// Calculate position more reliably
					const targetPosition = window.pageYOffset + rect.top - offset;

					// Use scrollTo with fallback for older mobile browsers
					if (window.scrollTo) {
						window.scrollTo({
							top: Math.max(0, targetPosition), // prevent negative scroll
							behavior: "smooth",
						});
					} else {
						// Fallback for older browsers
						window.scrollTop = Math.max(0, targetPosition);
					}
				}
			}, 300); // Reduced timeout for better responsiveness
		});
	};

	return (
		<>
			<div className="logo-wrapper">
				<img
					src="/assets/joyalifevertical_green_on_white_transparent.png"
					alt="joyalifevertical_green_on_white_transparent.png"
				/>
			</div>

			<div className="content-title">Scorecard</div>

			<div className="content-description">
				<div>
					Take a moment for yourself. This quick reflection will help you
					understand where you are today.
				</div>
				<br />
				<div>
					Your answers will help us better understand your needs and guide you
					toward a more purposeful and joyful life. ​ Our aim is to be able to
					live a long, healthy life and be able to look back at our lives with
					happiness and without regrets.​
				</div>
				<br />
				<div>
					{"Let’s begin your journey to a happier, more meaningful life!​"}
				</div>
				<br />
				<br />
				<div>
					<i>
						{
							"The following questions may vary depending on whether you’re currently working or not, and whether you’re single or in a relationship."
						}
					</i>
				</div>
			</div>

			<div className="form-wrapper">
				{isLoadingSurveyList ? (
					<div className="loading-questions">
						<BounceLoader color={bgColor} />
						<span>Loading questions...</span>
					</div>
				) : (
					<Form
						form={form}
						onFinish={onFinish}
						scrollToFirstError={true}
						onValuesChange={onValuesChange}
					>
						<Row gutter={[12, 0]}>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<Form.Item shouldUpdate noStyle>
									{() => {
										if (collapseItems.length > 0) {
											return (
												<CustomCollapse
													items={collapseItems.map((item) => {
														let extra = null;

														let answers = localStorage.getItem(
															"scorecardAnswers"
														)
															? JSON.parse(
																	localStorage.getItem("scorecardAnswers")
															  )
															: {};

														// check if completed (only for non-hidden items and not the first item)
														if (Number(item.key) !== 0) {
															let question_ids =
																item?.data?.form_questions?.reduce(
																	(acc, question) => acc.concat(question.id),
																	[]
																);

															let counter = 0;

															Object.keys(answers).forEach((key) => {
																let qid = Number(key.replace("q_", ""));

																if (
																	answers[key] &&
																	question_ids.includes(qid)
																) {
																	counter += 1;
																}
															});

															if (counter === question_ids.length) {
																extra = <div>Completed</div>;
															} else {
																if (
																	Number(lastActiveTab) === Number(item.key)
																) {
																	extra = <div>In Progress</div>;
																} else {
																	extra = (
																		<div
																			style={{
																				color: "#757575",
																			}}
																		>
																			Not Completed
																		</div>
																	);
																}
															}
														}

														return {
															key: item.key,
															label: item.label,
															children: item.children,
															hidden: item.hidden,
															extra: extra,
														};
													})}
													activeKey={collapseActiveKey}
													accordion
													expandIconPosition="end"
													expandIcon={({ isActive }) => (
														<FontAwesomeIcon
															icon={isActive ? faAngleUp : faAngleDown}
														/>
													)}
													onChange={(key) => {
														let formValues = answers;

														// figure out the target index (skipping hidden items)
														let targetIndex = handleCheckKey(key);

														// if targetIndex is -1, nothing to open
														if (targetIndex === -1) return;

														// find previous visible item index
														let prevIndex = targetIndex - 1;
														while (
															prevIndex >= 0 &&
															collapseItems[prevIndex] &&
															collapseItems[prevIndex].hidden
														) {
															prevIndex -= 1;
														}

														let error = false;

														if (prevIndex >= 0) {
															let prevItem = collapseItems[prevIndex];
															if (prevItem && !prevItem.hidden) {
																let data = prevItem?.data;
																let form_questions = data?.form_questions;

																if (
																	form_questions &&
																	form_questions.length > 0
																) {
																	let countRequired = 0;
																	let countAnswered = 0;

																	form_questions.forEach((question) => {
																		if (question.required) {
																			countRequired++;
																			let questionId = question.id;
																			let answer =
																				formValues[`q_${questionId}`];
																			console.log("answer: ", answer);
																			if (
																				answer !== undefined &&
																				answer !== null &&
																				answer !== ""
																			) {
																				countAnswered++;
																			}
																		}
																	});

																	if (
																		countRequired > 0 &&
																		countAnswered !== countRequired
																	) {
																		error = true;
																	}
																}
															}
														}

														setCheckError(error);

														if (!error) {
															setCollapseActiveKey(key);
															// fucus on first input of the opened item

															let scorecardAnswers = localStorage.getItem(
																"scorecardAnswers"
															)
																? JSON.parse(
																		localStorage.getItem("scorecardAnswers")
																  )
																: null;

															if (scorecardAnswers) {
																form.setFieldsValue(scorecardAnswers);
															}

															if (key.length > 0) {
																setLastActiveTab(key);
															}
														} else {
															form.submit();
															notification.error({
																message: "Scorecard",
																description:
																	"Please check all sections for any unanswered required questions.",
															});
														}

														handleChange(key);
													}}
												/>
											);
										}
									}}
								</Form.Item>
							</Col>

							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<Form.Item shouldUpdate noStyle>
									{() => {
										const formValues = answers;
										// last visible index
										// const lastVisibleIndex = collapseItems
										// 	.map((x, idx) => (!x.hidden ? idx : -1))
										// 	.filter((i) => i >= 0)
										// 	.pop();

										// const isOnLastVisible =
										// 	Number(collapseActiveKey) === lastVisibleIndex;
										const allRequiredAnswered =
											areAllRequiredAnswered(formValues);
										// console.log("allRequiredAnswered: ", allRequiredAnswered);

										return (
											<Flex gap={15} justify="center">
												<Button
													htmlType="submit"
													type="primary"
													className="btn-main-primary mt-20"
													disabled={!allRequiredAnswered || isLoadingSurveyList}
												>
													SUBMIT ASSESSMENT
												</Button>
											</Flex>
										);
									}}
								</Form.Item>
							</Col>
						</Row>
					</Form>
				)}
			</div>
		</>
	);
}
